import { store } from "../store";
import { setEnhancedConditionsDocumentsList } from "../../features/enhanced-conditions-documents_list/enhancedConditionsDocumentsListSlice";

export const getEnhancedConditionsDocumentsList = async ({
	loanGuid,
	apiRequest,
	handleErrorModal,
	handleCloseModal,
	errorKey,
}) => {
	try {
		const enhancedConditionsValue = await apiRequest({
			loanGuid,
		}).unwrap();

		store.dispatch(
			setEnhancedConditionsDocumentsList(enhancedConditionsValue?.data)
		);

		handleCloseModal?.();
		return enhancedConditionsValue;
	} catch (err) {
		if (errorKey) {
			handleErrorModal?.(errorKey, err);
		} else {
			handleErrorModal?.(err);
		}
		return null;
	}
};
